<ng-container>
  <c-container [fluid]="true">
    <button
      toggle="visible"
      cHeaderToggler
      [cSidebarToggle]="sidebarId"
      class="ps-1"
    >
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>
    <c-header-nav class="d-none d-lg-flex me-auto"> </c-header-nav>

    <c-header-nav class="d-none d-lg-flex">
      <!-- MENU ITEMS -->
    </c-header-nav>
    <c-header-nav class="ms-3">
      <c-dropdown alignment="end" variant="nav-item">
        <a cDropdownToggle cNavLink class="py-0" style="cursor: pointer">
          @if (user?.photo) {
            <c-avatar
              shape="rounded-1"
              size="md"
              [src]="user!.photo"
              status="success"
            ></c-avatar>
          } @else {
            <c-avatar
              color="secondary"
              shape="rounded-1"
              size="md"
              status="success"
              class="text-white fw-bold"
            >
              {{ userInitials }}
            </c-avatar>
          }
        </a>
        <ul cDropdownMenu class="pt-0 pr-5 w-auto">
          <li>
            <a (click)="goToSecuritySettings($event)" href="#" cDropdownItem>
              <svg cIcon class="me-2" name="cilShieldAlt"></svg>
              Sécurité (2FA)
            </a>
          </li>
          <li>
            <a (click)="logout($event)" href="#" cDropdownItem translate>
              <svg cIcon class="me-2" name="cilLockLocked"></svg>
              views.login.close
            </a>
          </li>
          <li></li>
        </ul>
      </c-dropdown>
    </c-header-nav> </c-container
></ng-container>
